import React from "react";
// DEADLINES
// --> COMPONENTS ??
export const calculateDifferenceDeadlineAndNoW = (date) => {
    if (date === null) return  <>Aucune échéance définie </>

    const actionDate = new Date(date);
    const actualDate = new Date();
    // One day in milliseconds
    const oneDay = 1000 * 60 * 60 * 24;

    // Calculating the time difference between two dates
    const diffInTime = actionDate.getTime() - actualDate.getTime();

    // Calculating the no. of days between two dates
    let diffInDays = Math.round(Math.ceil(diffInTime / oneDay));

    const DeadlineStyle = {
        color: getDeadlineColor(diffInDays),
        fontWeight: 800
    }

    if (diffInDays === -0 || diffInDays === 0) {
        return <span style={DeadlineStyle}> Aujourd'hui ! </span>
    }

    return (
        <span style={DeadlineStyle}> {`/ ${diffInDays} jour${diffInDays === 1 || diffInDays === -1 ? "" : "s"}`}</span>
    )
}

export const getDateInFrench = (deadline) => {
    const notADate = "Aucune modification"
    if (typeof deadline === "object") {
       if(deadline === null){
           return
       }
        deadline = deadline[0].trim()
    }
    if (deadline === notADate) {
        return deadline
    } else {
        const year = deadline.slice(0, 4)
        const month = deadline.slice(5, 7)
        const day = deadline.slice(8, 11)
        return day + "-" + month + "-" + year
    }
}

export const getDateInFrench2 = (deadline) => {
    const notADate = "Aucune modification"
    const test = new Date(deadline)
    const date = test.toLocaleString()
         if(!date){
             return
         }

         if (date === notADate) {
             return date
         } else {
             const year = date.slice(6, 11)
            const month = date.slice(3, 5)
             const day = date.slice(0, 2)
            return day + "-" + month + "-" + year
        }

}

export const getDeadlineColor = (date) => {
    if (date < 0) {
        return '#E9405B';
    } else if (date > 0) {
        return '#2F2E41';
    } else {
        return '#2F2E41';
    }
}
export const getCurrentDate = () => {
    const date = new Date(Date.now());
    const currentYear = date.getFullYear();
    const currentMonth = date.getMonth() + 1;
    const currentDay = date.getDate();
    return currentYear + "-" + currentMonth + "-" + currentDay;
}

export const getLateInfo = (entity) => {
    const today = new Date();
    const lastUpdate = Date.parse(entity.lastUpdate)
    const time = Math.abs(lastUpdate - today)
    const res = Math.ceil(time / (1000 * 60 * 60 * 24)) - 1
    if (res < 15) {
        return "upToDate"
    } else if (res > 30) {
        return "midLate"
    } else return ""
}

export const getCurrentDate2 = () => {
    const date = new Date(Date.now());
    const currentYear = date.getFullYear();
    let currentMonth = date.getMonth() + 1;
    let currentDay = date.getDate();
    if(currentMonth < 10){
         currentMonth = "0" + currentMonth
    }
    if(currentDay < 10){
        currentDay = "0" + currentDay
    }
    return currentYear + "-" + currentMonth + "-" + currentDay;
}
export const getNumberOfDayInHours = (total) => {
    const days = Math.floor(Math.abs(total) / 24);
    const remainMinutes = Math.abs(total) % 24
    const hours = Math.floor(remainMinutes)
    if (total >= 60) {
        return (days + " jours :  " + hours + " heures");
    } else if (total < 0) {
        return ("- " + days + " jours :  " + hours + " heures");
    } else {
        return `${total} heure${total > 0 ? "s" : ""}`
    }
}